import {
  Component, Inject, ViewChild, OnInit, TemplateRef, ComponentFactoryResolver, ViewContainerRef, ComponentRef,
  OnDestroy
} from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit, OnDestroy {
  @ViewChild('target', { read: ViewContainerRef, static: true })

  vcRef: ViewContainerRef;
  componentRef: ComponentRef<any>;
  cancelText: string = 'Cancelar';
  confirmText: string = 'Seleccionar';

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    private resolver: ComponentFactoryResolver,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (this.data.component) {
      const factory = this.resolver.resolveComponentFactory(this.data.component);
      this.componentRef = this.vcRef.createComponent(factory);
    }
    if (this.data.cancelText != undefined) this.cancelText = this.data.cancelText;
    if (this.data.confirmText != undefined) this.confirmText = this.data.confirmText;
  }

  onOkClick(): void {
    console.log('onOkClick');
    this.onSaveEvent.call(this, this.getComponentInstance()).then((result) => {
      console.log(result)
      if (result) {
        this.dialogRef.close(true);
      }
    });
  }

  onSaveEvent = (componentInstance: any) => {
    console.log('hola')
    return Promise.resolve(true);
  };

  onNoClick(): void {
    this.dialogRef.close();
  }

  public getComponentInstance() {
    console.log(this.componentRef)
    if (this.componentRef)
      return this.componentRef.instance;
    else
      return undefined;
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

}
